import React from 'react';
import './Error.scss';

const errorPayment = () => (
  <div className="error">
    <p className="error-body">
      <span>Sorry!!!</span>but the payment was not successful.
    </p>
  </div>
);


export default errorPayment


// WEBPACK FOOTER //
// ./src/app/containers/Error/errorPayment.js